import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { DetailLedger, DetailLedgerKind } from "projects/sepidz-web-framework/src/lib/models";
import { MisSetupService } from "projects/sepidz-web-framework/src/lib/services/missetup.service";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "ngx-detailledger-form",
  templateUrl: "./detailledger-form.component.html",
  styleUrls: ["./detailledger-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailLedgerFormComponent extends BaseFormComponent<DetailLedger> {
  private selecteddetailLedgeerkindId: number;
  private selecteddetailLedgeerkindStartCode: number;
  private selecteddetailLedgeerkindEndCode: number;
  constructor(private missetup: MisSetupService, protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
    this.missetup.getall();
  }
  async ngOnInit() {
    this.apiName = "DetailLedger";
    this.label = this.translate("ClientApp.BackOffice.ACC.DetaiLedger.DetaiLedger");
    super.ngOnInit();
  }
  onChange(value: DetailLedgerKind) {
    if (value && value.Id && this.isNewRow) {
      this.model.DetailLedgerKindId = value.Id;
      this.selecteddetailLedgeerkindId = value.Id;
      this.selecteddetailLedgeerkindStartCode = value.StartCode;
      this.selecteddetailLedgeerkindEndCode = value.EndCode;
      this.setMaxCode();
    }
  }
  setMaxCode() {
    if (this.missetup.getnumber("ACC", "DLLEN") === 0)
      this.sts.showDialog(
        this.translate("ClientApp.BackOffice.ACC.DetaiLedger.AccountingDontSetting"),
        this.translate("ClientApp.BackOffice.ACC.DetaiLedger.ErrorSetting")
      );

    if (this.columns && this.columns.length > 0) {
      var item = this.columns.filter(function (item) {
        return item.name === "Code";
      })[0];
      if (item) {
        item.maxLength = this.missetup.getnumber("ACC", "DLLEN");
        item.minLength = 1;
      }
    }
    this.httpCommonService
      .getMaxCodeWithParameter(
        this.apiName,
        this.selecteddetailLedgeerkindId,
        this.selecteddetailLedgeerkindStartCode,
        this.selecteddetailLedgeerkindEndCode
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data) => {
        if (!this.model) this.model === <DetailLedger>{};
        if (data) {
          this.model["Code"] = data as number;
        }
        this.setColumnAttribute();
        this.setFormGroup(this.model);
      });
    if (this.isNewRow) this.model.Active = true;
  }
  setColumnAttribute() {
    let maxformat = [9, 99, 999, 9999, 99999, 999999, 9999999, 99999999, 999999999, 9999999999];
    let DetailLedgerCodeLen = this.missetup.getnumber("ACC", "DLLEN");
    this.orignalColumns.forEach((x) => {
      if (x.name === "GroupLedgerId") x.disabled = !this.isNewRow;
      if (x.name === "Code") {
        if (this.selecteddetailLedgeerkindStartCode && this.selecteddetailLedgeerkindStartCode > 0) x.min = this.selecteddetailLedgeerkindStartCode;
        else x.min = 1;
        if (this.selecteddetailLedgeerkindEndCode && this.selecteddetailLedgeerkindEndCode > 0) x.max = this.selecteddetailLedgeerkindEndCode;
        else x.max = maxformat[DetailLedgerCodeLen - 1];
      }
    });
  }
}
